"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.removeFileRequest = exports.fetchFilesRequest = exports.saveMetasFailed = exports.saveMetasSuccess = exports.saveMetasRequest = exports.toggleExcludeStatusFailed = exports.toggleExcludeStatusSuccess = exports.toggleExcludeStatusRequest = exports.answerQuestionValidationFailed = exports.answerQuestionFailed = exports.answerQuestionSuccess = exports.answerQuestionRequest = exports.toggleAnswerQuestion = exports.addQuestionValidationFailed = exports.addQuestionFailed = exports.addQuestionSuccess = exports.addQuestionRequest = exports.toggleAddQuestion = exports.unselect = exports.select = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = exports.CrudActions = exports.ListActions = void 0;
const ActionTypes = require("../../actionTypes/bid/questions");
const _ListActions = require("../../modules/files/list/actions");
const _CrudActions = require("../../modules/files/crud/actions");
exports.ListActions = _ListActions.default('bid-answer-file');
exports.CrudActions = _CrudActions.default('bid-answer-file');
function fetchRequest(bid) {
    return {
        type: ActionTypes.FETCH_REQUEST,
        payload: bid
    };
}
exports.fetchRequest = fetchRequest;
function fetchSuccess(questions) {
    return {
        type: ActionTypes.FETCH_SUCCESS,
        payload: questions
    };
}
exports.fetchSuccess = fetchSuccess;
function fetchFailed(payload) {
    return {
        type: ActionTypes.FETCH_FAILED,
        payload
    };
}
exports.fetchFailed = fetchFailed;
function select(questions) {
    return {
        type: ActionTypes.SELECT,
        payload: questions
    };
}
exports.select = select;
function unselect(questions) {
    return {
        type: ActionTypes.UNSELECT,
        payload: questions
    };
}
exports.unselect = unselect;
function toggleAddQuestion(status) {
    return {
        type: ActionTypes.TOGGLE_ADD_QUESTION,
        payload: status
    };
}
exports.toggleAddQuestion = toggleAddQuestion;
function addQuestionRequest(bid, question) {
    return {
        type: ActionTypes.ADD_QUESTION_REQUEST,
        payload: {
            bid,
            question
        }
    };
}
exports.addQuestionRequest = addQuestionRequest;
function addQuestionSuccess() {
    return {
        type: ActionTypes.ADD_QUESTION_SUCCESS
    };
}
exports.addQuestionSuccess = addQuestionSuccess;
function addQuestionFailed(payload) {
    return {
        type: ActionTypes.ADD_QUESTION_FAILED,
        payload
    };
}
exports.addQuestionFailed = addQuestionFailed;
function addQuestionValidationFailed(payload) {
    return {
        type: ActionTypes.ADD_QUESTION_VALIDATION_FAILED,
        payload
    };
}
exports.addQuestionValidationFailed = addQuestionValidationFailed;
function toggleAnswerQuestion(questions, status) {
    return {
        type: ActionTypes.TOGGLE_ANSWER_QUESTION,
        payload: { questions, status }
    };
}
exports.toggleAnswerQuestion = toggleAnswerQuestion;
function answerQuestionRequest(bid, questions) {
    return {
        type: ActionTypes.ANSWER_QUESTION_REQUEST,
        payload: {
            bid,
            questions
        }
    };
}
exports.answerQuestionRequest = answerQuestionRequest;
function answerQuestionSuccess() {
    return {
        type: ActionTypes.ANSWER_QUESTION_SUCCESS
    };
}
exports.answerQuestionSuccess = answerQuestionSuccess;
function answerQuestionFailed(payload) {
    return {
        type: ActionTypes.ANSWER_QUESTION_FAILED,
        payload
    };
}
exports.answerQuestionFailed = answerQuestionFailed;
function answerQuestionValidationFailed(payload) {
    return {
        type: ActionTypes.ANSWER_QUESTION_VALIDATION_FAILED,
        payload
    };
}
exports.answerQuestionValidationFailed = answerQuestionValidationFailed;
function toggleExcludeStatusRequest(bid, questions) {
    return {
        type: ActionTypes.TOGGLE_EXCLUDE_STATUS_REQUEST,
        payload: { bid, questions }
    };
}
exports.toggleExcludeStatusRequest = toggleExcludeStatusRequest;
function toggleExcludeStatusSuccess() {
    return {
        type: ActionTypes.TOGGLE_EXCLUDE_STATUS_SUCCESS
    };
}
exports.toggleExcludeStatusSuccess = toggleExcludeStatusSuccess;
function toggleExcludeStatusFailed(payload) {
    return {
        type: ActionTypes.TOGGLE_EXCLUDE_STATUS_FAILED,
        payload
    };
}
exports.toggleExcludeStatusFailed = toggleExcludeStatusFailed;
function saveMetasRequest() {
    return {
        type: ActionTypes.SAVE_METAS_REQUEST
    };
}
exports.saveMetasRequest = saveMetasRequest;
function saveMetasSuccess() {
    return {
        type: ActionTypes.SAVE_METAS_SUCCESS
    };
}
exports.saveMetasSuccess = saveMetasSuccess;
function saveMetasFailed(payload) {
    return {
        type: ActionTypes.SAVE_METAS_FAILED,
        payload
    };
}
exports.saveMetasFailed = saveMetasFailed;
exports.fetchFilesRequest = exports.ListActions.fetchRequest;
exports.removeFileRequest = exports.CrudActions.deleteRequest;
function clear() {
    return {
        type: ActionTypes.CLEAR
    };
}
exports.clear = clear;
//# sourceMappingURL=questions.js.map